import React from 'react';

export const HealthPage: React.FC = () => <div>OK!</div>;
